import React, {createContext, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useMatch} from 'react-router-dom';
import {config} from '../init/config';

interface LocaleContext {
    readonly language: string;
    readonly country: string;
}

export const LocaleContext = createContext<LocaleContext>({
    language: config.DLS_LANGUAGE_DEFAULT,
    country: config.DLS_COUNTRY_DEFAULT
});

const COUNTRY_LANGUAGE_PATH = '/:country/:language/*';
const LANGUAGE_COUNTRY_PATH = '/:language/:country/*';
const LANGUAGE_ONLY_PATH = '/:language/*';

const LocaleContextProvider: React.FC = (props) => {
    let contentPathPattern = COUNTRY_LANGUAGE_PATH;
    if (config.LANGUAGE_ONLY_MODE_ACTIVE) {
        contentPathPattern = LANGUAGE_ONLY_PATH;
    } else if (config.SWAP_COUNTRY_LANGUAGE_ACTIVE) {
        contentPathPattern = LANGUAGE_COUNTRY_PATH;
    }

    const pathParams = useMatch(contentPathPattern)?.params;
    const {i18n} = useTranslation();

    let language = pathParams?.language ?? config.DLS_LANGUAGE_DEFAULT;
    let country = pathParams?.country ?? config.DLS_COUNTRY_DEFAULT;

    useEffect(() => {
        language = pathParams?.language ?? config.DLS_LANGUAGE_DEFAULT;
        country = pathParams?.country ?? config.DLS_COUNTRY_DEFAULT;
        i18n.changeLanguage(language);
    }, [pathParams, config.DLS_COUNTRY_DEFAULT, config.DLS_LANGUAGE_DEFAULT]);

    return (
        <LocaleContext.Provider
            value={{
                language: language,
                country: country
            }}
        >
            {props.children}
        </LocaleContext.Provider>
    );
};

export default LocaleContextProvider;
